import { useState } from "react";
import { useSelector } from "react-redux";

import MachineSelection from "~/components/MachineSelection/MachineSelection.jsx";
import MachineList from "~/components/MachineList/MachineList.jsx";
import FrequencySelection from "~/components/FrequencySelection/FrequencySelection.jsx";
import CapsuleSelection from "~/components/CapsuleSelection/CapsuleSelection.jsx";
import CapsuleSelectionPopup from "~/components/CapsuleSelectionPopup/CapsuleSelectionPopup.jsx";
import StickyAddToCart from "~/components/StickyAddToCart/StickyAddToCart.jsx";
import { TailSpin } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useGetDynamicBoxQuery } from "../../store/services/dynamicBoxApi";
import useHandlers from "~/hooks/useHandlers";

import { PRODUCT_PLATFORM_ID, PRODUCT_PLATFORM_ID_DELIVERY_COMMITMENT } from "~/utils/constants";

import "./BuildYourBoxMain.css";

const BuildYourBoxMain = () => {
  const machine = useSelector((state) => state.machine.machine);
  const selectedCapsules = useSelector((state) => state.capsules.selectedCapsules);
  const [isLoading, setIsLoading] = useState(false);

  const notifyError = () =>
    toast.error(
      "Please select either 'I need a machine' or 'I already have a machine' to continue."
    );

  const productPlatformIds = [PRODUCT_PLATFORM_ID, PRODUCT_PLATFORM_ID_DELIVERY_COMMITMENT];

  const { data, dynamicBoxError, dynamicBoxLoading } = useGetDynamicBoxQuery(productPlatformIds);

  if (dynamicBoxLoading) {
    return <p>Loading...</p>;
  }

  if (dynamicBoxError) {
    return <p>Error loading dynamic boxes: {dynamicBoxError.data}</p>;
  }

  const dynamicBoxMainData = data?.data1;
  const deliveryCommitmentData = data?.data2;

  console.log("data", data);

  const { handleAddToCart, handleQuantityChange } = useHandlers({
    selectedCapsules,
    setIsLoading,
    notifyError,
  });

  return (
    <div className="build-your-box">
      <MachineSelection />

      {machine === "need" && <MachineList />}

      <FrequencySelection
        data={dynamicBoxMainData}
        deliveryCommitmentData={deliveryCommitmentData}
      />

      <CapsuleSelection
        data={dynamicBoxMainData}
        selectedCapsules={selectedCapsules}
        handleQuantityChange={handleQuantityChange}
      />

      <CapsuleSelectionPopup
        data={dynamicBoxMainData}
        selectedCapsules={selectedCapsules}
        handleQuantityChange={handleQuantityChange}
      />

      <StickyAddToCart
        data={dynamicBoxMainData}
        deliveryCommitmentData={deliveryCommitmentData}
        handleAddToCart={handleAddToCart}
        selectedCapsules={selectedCapsules}
      />

      <ToastContainer className="custom-toast-container" />

      {isLoading && (
        <TailSpin
          visible={true}
          height="120"
          width="120"
          color="#008fbb"
          ariaLabel="tail-spin-loading"
          radius="2"
          wrapperClass="custom-loader"
        />
      )}
    </div>
  );
};

export default BuildYourBoxMain;
